import { useLazyQuery } from '@apollo/client';
import { GET_DOCUMENT_DOWNLOAD_TOKEN } from '../graphql/document';
import { fetchFileForView, prefetchFileAndDownload } from '../utilities';

export const useDocumentDownload = () => {
  const [ getDownloadToken ] = useLazyQuery( GET_DOCUMENT_DOWNLOAD_TOKEN, {
    fetchPolicy: 'no-cache'
  } );

  const createToken = async ( fileId: string ): Promise<string> => {
    const { data } = await getDownloadToken( { variables: { input: { file_id: fileId } } } );
    const result = data?.documentDownloadToken;

    if ( result?.__typename !== 'QueryDocumentDownloadTokenSuccess' || !result.data ) {
      throw new Error( result?.message ?? 'File download is not authorized.' );
    }

    return result.data;
  };

  const downloadDocument = async ( file: any ): Promise<void> => {
    const token = await createToken( file.id );
    await prefetchFileAndDownload( file.path, file.name, false, token );
  };

  const previewDocument = async ( file: any ): Promise<string> => {
    const token = await createToken( file.id );
    return await fetchFileForView( file.path, false, token );
  };

  return { downloadDocument, previewDocument };
};
